export const appointmentKeys = {
  all: ['appointments'] as const,
  agendas: () => [...appointmentKeys.all, 'agenda'] as const,
  agenda: (startDate: string, endDate?: string, doctorId?: string) =>
    [
      ...appointmentKeys.agendas(),
      startDate,
      endDate ?? startDate,
      doctorId ?? 'all',
    ] as const,
  lists: () => [...appointmentKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) =>
    [...appointmentKeys.lists(), filters] as const,
  bookableDoctors: () => [...appointmentKeys.all, 'bookableDoctors'] as const,
};
